import './LuckyWheel.less';

import React from 'react';
import LuckyWheelConfirm from 'nike-ui/src/components/lucky-wheel/LuckyWheelConfirm';
import Dialog from '@/ui/dialogs/Dialog';
import { closeLuckyWheelConfirm, confirmBonus, confirmRejectBonus } from '@/luckyWheel/h&s';

const LuckyWheelConfirmDialog = ({ title, subTitle }) => {
    return (
        <Dialog className="confirm-dialog" modal>
            <LuckyWheelConfirm
                title={title}
                subTitle={subTitle}
                confirmBonus={confirmBonus}
                rejectBonus={confirmRejectBonus}
                closeDialog={() => closeLuckyWheelConfirm()}
            />
        </Dialog>
    );
};

export default LuckyWheelConfirmDialog;
